import { render, staticRenderFns } from "./Injection.vue?vue&type=template&id=43f64026&"
import script from "./Injection.vue?vue&type=script&lang=js&"
export * from "./Injection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports